window.newSheet=function(o,e,i,n="xlsx"){try{const t=window.XLSX.utils.book_new(),w=window.XLSX.utils.json_to_sheet(i);window.XLSX.utils.sheet_add_aoa(w,[e],{origin:"A1"}),window.XLSX.utils.book_append_sheet(t,w,"Sheet1"),window.XLSX.writeFile(t,o+"."+n)}catch(o){console.error(o)}};


// WEBPACK FOOTER //
// ./public/js/general/xlsx.min.js